<template>
  <b-form @submit.prevent="modifyUser">
    <b-card class="border0" body-class="">
      <b-row>
        <b-col>
          <label>ID</label>
          <b-form-input v-model="userinfo.userid" disabled></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>이름</label>
          <b-form-input v-model="userinfo.username" required></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>전화번호</label>
          <b-form-input v-model="userinfo.mobilenum"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>이메일</label>
          <b-form-input v-model="userinfo.email"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>회사 이름</label>
          <b-form-input v-model="userinfo.companyname"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>회사 부서</label>
          <b-form-input v-model="userinfo.companydept"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>회사 직위</label>
          <b-form-input v-model="userinfo.companypos"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>회사 전화번호</label>
          <b-form-input v-model="userinfo.officetel"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>권한</label>
          <b-form-select
            v-model="userinfo.grade"
            :options="gradeOptions"
            disabled
          ></b-form-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>메세지 수신</label>
          <b-form-checkbox
            v-model="userinfo.smsyn"
            value="Y"
            unchecked-value="N"
            >SMS</b-form-checkbox
          >
          <b-form-checkbox
            v-model="userinfo.emailyn"
            value="Y"
            unchecked-value="N"
            >이메일</b-form-checkbox
          >
        </b-col>
      </b-row>
    </b-card>
    <div class="btnGrp">
      <div class="jcse">
        <b-button class="empty-modBtn" type="submit"
          ><i class="fa fa-edit"></i>변경</b-button
        >
        <b-button class="empty-delBtn mr0" @click="closeUser"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </b-form>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
// import utils from './common/utils'

export default {
  computed: {
    ...mapGetters(["getAlertOptions", "getConfirmOptions"]),
  },
  props: {
    userid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      userinfo: {},
      gradeOptions: [],
    };
  },
  created() {
    this.getDefaultCodes();
  },
  beforeMount() {},
  mounted() {
    this.getUserInfo();
  },
  destroyed() {},
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    getDefaultCodes() {
      var reqBody = {
        codegrp: "usergrade",
      };
      this.$http
        .post("/comn/code", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var value = [];
            // 장비 상태
            var usergrade = res.data.usergrade;
            for (let i = 0; i < usergrade.length; i++) {
              value.push({
                value: usergrade[i].cd,
                text: usergrade[i].nm,
              });
            }
            this.gradeOptions = value;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getUserInfo() {
      var reqBody = {
        id: this.userid,
      };
      this.$http
        .post("/comn/userinfo", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.userinfo = res.data.data;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    modifyUser() {
      var reqBody = this.userinfo;
      console.log(reqBody);
      this.$http
        .post("/comn/updateUserInfo", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.setAlertTitle("사용자 정보 변경 완료");
            this.$bvModal
              .msgBoxOk(
                "사용자 정보 변경 완료되었습니다.",
                this.getAlertOptions
              )
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    closeUser() {
      this.$bvModal.hide("userInfoModal");
    },
  },
};
</script>

<style lang="scss">
#userInfoModal .modal-dialog {
  max-width: 500px;
  & .modal-content {
    & .card {
      & .card-body {
        border-radius: 10px;
        padding: 10px 20px;
        & .row {
          height: 50px;
          & .col {
            padding: 10px 0;
            & label {
              width: 100px;
              height: 100%;
            }
            & input,
            & select {
              width: 290px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userInfoModal.vue